import { AnnularRingFeature3D } from 'features/assetViz/objects/features/AnnularRingFeature3D'
import { CoatingRegionFeature3D } from 'features/assetViz/objects/features/CoatingRegion3D'
import { ConeCircumferentialWeldFeature3D } from 'features/assetViz/objects/features/cone/ConeCircumferentialWeldFeature3D'
import { ConeRadialWeldFeature3D } from 'features/assetViz/objects/features/cone/ConeRadialWeldFeature3D'
import { ConicalPlateFeature3D } from 'features/assetViz/objects/features/cone/ConicalPlateFeature3D'
import { SphericalPlateFeature3D } from 'features/assetViz/objects/features/dome/SphericalPlateFeature3D'
import { FixedSensorFeature3D } from 'features/assetViz/objects/features/FixedSensorFeature3D'
import { HorizontalWeldFeature3D } from 'features/assetViz/objects/features/HorizontalWeldFeature3D'
import { LeakDetectionValveFeature3D } from 'features/assetViz/objects/features/LeakDetectionValveFeature3D'
import { LinerRegionFeature3D } from 'features/assetViz/objects/features/LinerRegion3D'
import { ManwayFeature3D } from 'features/assetViz/objects/features/ManwayFeature3D'
import { NozzleFeature3D } from 'features/assetViz/objects/features/NozzleFeature3D'
import { PipeCircumferentialWeldFeature3D } from 'features/assetViz/objects/features/pipeSection/PipeCircumferentialWeldFeature3D'
import { PipeSeamWeldFeature3D } from 'features/assetViz/objects/features/pipeSection/PipeSeamWeldFeature3D'
import { PipeWrapFeature3D } from 'features/assetViz/objects/features/pipeSection/PipeWrapFeature3D'
import { PlateFeature3D } from 'features/assetViz/objects/features/PlateFeature3D'
import { PolygonalPlateFeature3D } from 'features/assetViz/objects/features/PolygonalPlateFeature3D'
import { RectangularManwayFeature3D } from 'features/assetViz/objects/features/RectangularManwayFeature3D'
import { DeckBittFeature3D } from 'features/assetViz/objects/features/shipDeck/DeckBittFeature3D'
import { DeckBulkheadFeature3D } from 'features/assetViz/objects/features/shipDeck/DeckBulkheadFeature3D'
import { DeckChockFeature3D } from 'features/assetViz/objects/features/shipDeck/DeckChockFeature3D'
import { DeckCoamingFeature3D } from 'features/assetViz/objects/features/shipDeck/DeckCoamingFeature3D'
import { DeckCompartmentFeature3D } from 'features/assetViz/objects/features/shipDeck/DeckCompartmentFeature3D'
import { DeckDoorFeature3D } from 'features/assetViz/objects/features/shipDeck/DeckDoorFeature3D'
import { DeckDrainFeature3D } from 'features/assetViz/objects/features/shipDeck/DeckDrainFeature3D'
import { DeckHatchFeature3D } from 'features/assetViz/objects/features/shipDeck/DeckHatchFeature3D'
import { DeckLadderFeature3D } from 'features/assetViz/objects/features/shipDeck/DeckLadderFeature3D'
import { DeckLockerFeature3D } from 'features/assetViz/objects/features/shipDeck/DeckLockerFeature3D'
import { VerticalWeldFeature3D } from 'features/assetViz/objects/features/VerticalWeldFeature3D'
import flattenDeep from 'lodash/flattenDeep'
import {
  GeckoAnnularRing,
  GeckoCoatingRegion,
  GeckoConeCircumferentialWeld,
  GeckoConeRadialWeld,
  GeckoConicalPlate,
  GeckoFeatureModelType,
  GeckoFixedSensor,
  GeckoHorizontalWeld,
  GeckoLeakDetectionValve,
  GeckoLinerRegion,
  GeckoManway,
  GeckoNozzle,
  GeckoPipeCircumferentialWeld,
  GeckoPipeSeamWeld,
  GeckoPipeWrap,
  GeckoPlate,
  GeckoPolygonalPlate,
  GeckoRectangularManway,
  GeckoShipDeckBitt,
  GeckoShipDeckBulkhead,
  GeckoShipDeckChock,
  GeckoShipDeckCoaming,
  GeckoShipDeckCompartment,
  GeckoShipDeckDoor,
  GeckoShipDeckDrain,
  GeckoShipDeckHatch,
  GeckoShipDeckLadder,
  GeckoShipDeckLocker,
  GeckoSphericalPlate,
  GeckoVerticalWeld,
} from 'types'

type SupportedFeatureDispatchClass =
  | GeckoPlate
  | GeckoVerticalWeld
  | GeckoHorizontalWeld
  | GeckoConeCircumferentialWeld
  | GeckoConeRadialWeld
  | GeckoManway
  | GeckoRectangularManway
  | GeckoNozzle
  | GeckoLeakDetectionValve
  | GeckoFixedSensor
  | GeckoShipDeckCompartment
  | GeckoShipDeckBitt
  | GeckoShipDeckCoaming
  | GeckoShipDeckChock
  | GeckoShipDeckHatch
  | GeckoShipDeckLocker
  | GeckoShipDeckLadder
  | GeckoShipDeckBulkhead
  | GeckoShipDeckDoor
  | GeckoShipDeckDrain
  | GeckoPipeSeamWeld
  | GeckoPipeCircumferentialWeld
  | GeckoPipeWrap
  | GeckoConicalPlate
  | GeckoPolygonalPlate
  | GeckoCoatingRegion
  | GeckoSphericalPlate
  | GeckoLinerRegion
  | GeckoAnnularRing

type Nested<T> = T[] | Nested<T>[]

interface FeatureDispatchProps {
  features: Nested<SupportedFeatureDispatchClass>
}

export const FeatureDispatch = ({ features }: FeatureDispatchProps) => {
  const flatFeatures = flattenDeep(features)
  return (
    <>
      {flatFeatures.map((feature) =>
        feature.type === GeckoFeatureModelType.Manway ? (
          <ManwayFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.RectangularManway ? (
          <RectangularManwayFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.Nozzle ? (
          <NozzleFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.VerticalWeld ? (
          <VerticalWeldFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.HorizontalWeld ? (
          <HorizontalWeldFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.CoatingRegion ? (
          <CoatingRegionFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.LinerRegion ? (
          <LinerRegionFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.Plate ? (
          <PlateFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.FixedSensor ? (
          <FixedSensorFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.PolygonalPlate ? (
          <PolygonalPlateFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.ShipDeckCompartment ? (
          <DeckCompartmentFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.ShipDeckBitt ? (
          <DeckBittFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.ShipDeckCoaming ? (
          <DeckCoamingFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.ShipDeckChock ? (
          <DeckChockFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.ShipDeckHatch ? (
          <DeckHatchFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.ShipDeckLocker ? (
          <DeckLockerFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.ShipDeckLadder ? (
          <DeckLadderFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.ShipDeckBulkhead ? (
          <DeckBulkheadFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.ShipDeckDoor ? (
          <DeckDoorFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.ShipDeckDrain ? (
          <DeckDrainFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.SphericalPlate ? (
          <SphericalPlateFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.PipeCircumferentialWeld ? (
          <PipeCircumferentialWeldFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.PipeSeamWeld ? (
          <PipeSeamWeldFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.PipeWrap ? (
          <PipeWrapFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.ConePlate ? (
          <ConicalPlateFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.ConeRadialWeld ? (
          <ConeRadialWeldFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.ConeCircumferentialWeld ? (
          <ConeCircumferentialWeldFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.LeakDetectionValve ? (
          <LeakDetectionValveFeature3D key={feature.id} model={feature} />
        ) : feature.type === GeckoFeatureModelType.AnnularRing ? (
          <AnnularRingFeature3D key={feature.id} model={feature} />
        ) : null
      )}
    </>
  )
}
